module.exports = __webpack_public_path__ + "static/media/bogazici-filarmoni-orkestrasi-2.e12bedbf.jpg";